import { type CSSProperties, FC } from "react";

export type SeoRenderProps = { title?: string; description?: string };

const headingStyle: CSSProperties = {
  textAlign: "center",
  color: "rgb(125, 135, 156)",
  margin: 0,
  fontSize: "1rem",
  fontWeight: 400,
};

/** SSR h1/h2 from metadata; visually hidden (`display: none`) for layout. */
const SeoRender: FC<SeoRenderProps> = ({ title, description }) => {
  if (!title && !description) return null;
  return (
    <div style={{ display: "none" }} data-seo-render>
      {title ? <h1 style={headingStyle}>{title}</h1> : null}
      {description ? <h2 style={headingStyle}>{description}</h2> : null}
    </div>
  );
};

SeoRender.displayName = "SeoRender";

export default SeoRender;
